import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { BUSINESS_LINE } from "common/utils/app-registry/contants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";
import { useState } from "react";
import { cn } from "tailwind-variants";
import "./DtfSpanglesActions.scss";

export default function DtfSpanglesActions({ isArtworkInvalid = false, ...restProps }) {
  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();
  const [resizeCounter, setResizeCounter] = useState(-1);

  function artworks() {
    return store.artworks;
  }

  function removeBgLoading() {
    return store.removeBgLoading;
  }

  function lastSpangledDimensions() {
    return spanglesStore.lastSpangledDimensions;
  }

  function spanglesLoading() {
    return spanglesStore.spanglesLoading;
  }

  function spangleSizeEdited() {
    return spanglesStore.spangleSizeEdited;
  }

  function spangleSizeEditing() {
    return spanglesStore.spangleSizeEditing;
  }

  function originalArtworkUrl() {
    return spanglesStore.originalArtworkUrl;
  }

  function allAPIsCompleted() {
    return spanglesStore.allAPIsCompleted;
  }

  function invalidSpangleSelected() {
    return spanglesStore.invalidSpangleSelected;
  }

  function firstArtwork() {
    return artworks()[0];
  }

  function isSpangleItButtonDisabled() {
    const { width, height } = lastSpangledDimensions();
    const { width: originalWidth, height: originalHeight } = firstArtwork();
    const isDimensionSame =
      parseFloat(width) === parseFloat(originalWidth) &&
      parseFloat(height) === parseFloat(originalHeight);
    return (
      !allAPIsCompleted() ||
      isArtworkInvalid ||
      removeBgLoading() ||
      (spangleSizeEditing() && isDimensionSame)
    );
  }

  function isButtonDisabled() {
    return spanglesLoading() || !allAPIsCompleted();
  }

  function showEditSizeButton() {
    return spangleSizeEdited() && !invalidSpangleSelected();
  }

  function showSpangleItButton() {
    return !spangleSizeEdited() || spanglesLoading() || invalidSpangleSelected();
  }

  function spangleItButtonLabel() {
    return allAPIsCompleted() && !spanglesLoading() ? "Spangle It!" : "Loading...";
  }

  function getSpangleVariations(...args) {
    return spanglesStore.getSpangleVariations(...args);
  }

  function setSpangleMode(...args) {
    return spanglesStore.setSpangleMode(...args);
  }

  function updateArtworkValues(...args) {
    return store.updateArtworkValues(...args);
  }

  function changeMode(mode) {
    setSpangleMode(mode);
  }

  function logResizeCounter() {
    const newCounter = invalidSpangleSelected() ? resizeCounter : resizeCounter + 1;
    setResizeCounter(newCounter);
    submitDtfEvent("spangle_button_clicked", {
      artwork_url: originalArtworkUrl(),
      resize_counter: newCounter,
      business_line: BUSINESS_LINE.SPANGLE
    });
  }

  function spangleIt() {
    const processTimeStamp = Date.now();
    logResizeCounter();
    if (firstArtwork().spangled) {
      updateArtworkValues({
        index: 0,
        spangled: false,
        spangledImageUrl: null
      });
    }
    updateArtworkValues({
      index: 0,
      processTimeStamp,
      isLoading: true,
      progress: 100,
      currentProgress: 0
    });
    getSpangleVariations({
      isRetry: invalidSpangleSelected(),
      processTimeStamp
    });
  }

  return (
    <div {...restProps} className={cn("spangle-actions scope-f7214a82")}>
      {showEditSizeButton() ? (
        <button
          className={cn(
            "spangle-actions__button spangle-actions__button--secondary scope-f7214a82"
          )}
          disabled={isButtonDisabled()}
          type="button"
          onClick={() => {
            changeMode("edit-size");
          }}
          data-testid="spangle-actions-button"
        >
          {" "}
          Edit Size{" "}
        </button>
      ) : null}
      {spangleSizeEditing() ? (
        <button
          className={cn("spangle-actions__button spangle-actions__button--text scope-f7214a82")}
          disabled={isButtonDisabled()}
          type="button"
          onClick={() => {
            changeMode("size-edited");
          }}
          data-testid="spangle-actions-button-1"
        >
          {" "}
          Cancel{" "}
        </button>
      ) : null}
      {showSpangleItButton() ? (
        <button
          className={cn("spangle-actions__button spangle-actions__button--primary scope-f7214a82")}
          disabled={isSpangleItButtonDisabled()}
          type="button"
          onClick={spangleIt}
          data-testid="spangle-actions-button-2"
        >
          <UseSvg
            className={cn("spangle-actions__spangle-icon scope-f7214a82")}
            icon="spangle-wand"
            data-testid="spangle-actions-spangle-icon"
          />{" "}
          {spangleItButtonLabel()}
        </button>
      ) : null}
    </div>
  );
}
